module.exports = "<div class=\"<%= sideBySideLayout %>\">\r\n    <div ng-transclude=\"left\" class=\"<%= left %>\"></div>\r\n    <div ng-transclude=\"right\" class=\"<%= right %>\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/side-by-side-layout/SideBySideLayout.html
// module id = 956
// module chunks = 0